<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="my-3">
  <h2>Inspection Record - {{ this.inventoryData?.inventoryId }}</h2>
</div>

<div [ngClass]="!loading ? 'block' : 'hidden'">
  <section id="inspectDetails">
    <nz-card>
      <div>
        <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
          <h5>Inspection Details</h5>
          <div class="flex space-x-1" *appHasAnyPrivilege="'REPORT_GENERATE'">
            <button class="min-[410px]:hidden" *ngIf="
                this.inventoryData?.before?.inspectionDetails?.reason ===
                'Initial' && this.fleetData?.generalInformation?.vehicleType === 'RENT'
              " nz-button nzType="primary" (click)="showReportGenerate(); generatePdf()">
              Generate Initial Inspection
            </button>
            <button class="hidden min-[410px]:block" *ngIf="
                this.inventoryData?.before?.inspectionDetails?.reason ===
                'Initial' && this.fleetData?.generalInformation?.vehicleType === 'RENT'
              " nz-button nzType="primary" (click)="showReportGenerate(); generatePdf()">Generate Initial Inspection
              Report
            </button>
            <button *ngIf="(this.inventoryData?.before?.inspectionDetails?.reason !==
                'Initial' || this.fleetData?.generalInformation?.vehicleType !== 'RENT')" nz-button nzType="primary"
              (click)="showGenerateInventoryReportPopup()">
              Generate Inspection Report
            </button>
            <!-- Dropdown button -->
            <button *appHasAnyPrivilege="'INVENTORY_RECORDS_UPDATE,INVENTORY_RECORDS_DELETE'"
              class="outline-button more-dropdown" nz-button nz-dropdown [nzDropdownMenu]="menu"
              nzPlacement="bottomCenter">
              <span nz-icon nzType="more" nzTheme="outline"></span>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item nz-popconfirm nz-button (click)="afterInspection(inventoryData._id)"
                  *ngIf="hasPermission('INVENTORY_RECORDS_UPDATE') && (inventoryData.before.inspectionDetails?.reason !== 'Initial' && !inventoryData.after.inspectionDetails?.reason)">
                  Do After Inspection
                </li>
                <li nz-menu-item nz-popconfirm nz-button
                  *ngIf="hasPermission('INVENTORY_RECORDS_UPDATE') && (inventoryData.before.inspectionDetails?.reason === 'Initial' && !inventoryData.after.inspectionDetails)"
                  (click)="finalInspection(inventoryData._id)">Save To Final Records
                </li>
                <a nz-popconfirm nzPopconfirmTitle="Are you sure you want to delete this record?"
                  nzPopconfirmPlacement="bottom" (nzOnConfirm)="deleteInventory(this.inventoryData._id)">
                  <li
                    *ngIf="hasPermission('INVENTORY_RECORDS_DELETE') && (inventoryData.before.inspectionDetails?.reason !== 'Initial')"
                    nz-menu-item nz-popconfirm nz-button nzDanger>Delete
                  </li>
                </a>
              </ul>
            </nz-dropdown-menu>
          </div>
        </div>

        <div class="mt-5 grid md:grid-cols-2 xl:grid-cols-3 gap-8">
          <div class="sub-section" style="height: 100%">
            <div class="item-row">
              <p class="subject-name">Reason</p>
              <p class="subject-data">
                {{ this.inventoryData?.before?.inspectionDetails?.reason }}
              </p>
            </div>
            <div class="item-row" *ngIf="this.inventoryData?.before?.inspectionDetails?.reason === 'Other'">
              <p class="subject-name">Other Reason</p>
              <p class="subject-data">
                {{ this.inventoryData?.before?.inspectionDetails?.otherReason }}
              </p>
            </div>
            <div class="item-row">
              <p class="subject-name">Registration Number</p>
              <p class="subject-data">
                {{ this.fleetData.vehicleDetails.registrationNumber }}
              </p>
            </div>
            <div class="item-row">
              <p class="subject-name">Model</p>
              <p class="subject-data">
                {{ this.fleetData.vehicleDetails.vehicleModel }}
              </p>
            </div>
            <div class="item-row" *ngIf="
                this.inventoryData?.before?.inspectionDetails?.reason ===
                'Office Use' || this.inventoryData?.before?.inspectionDetails?.reason ===
                'Transfer' || this.inventoryData?.before?.inspectionDetails?.reason ===
                'Rent'
              ">
              <p class="subject-name">SR Booking Id</p>
              <p class="subject-data clickable" (click)="goToBooking()">
                {{ selectedBooking.refNo }}
              </p>
            </div>
            <div class="item-row" *ngIf="
                this.inventoryData?.before?.inspectionDetails?.reason ===
                'Office Use' || this.inventoryData?.before?.inspectionDetails?.reason ===
                'Transfer' || this.inventoryData?.before?.inspectionDetails?.reason ===
                'Rent'
              ">
              <p class="subject-name">Booking Type</p>
              <p class="subject-data">
                {{ selectedBooking.type ? selectedBooking.type : '-' }}
              </p>
            </div>
          </div>

          <div class="sub-section" style="height: 100%">
            <p class="font-semibold mb-2">Before</p>
            <div class="item-row">
              <p class="subject-name">Done By</p>
              <p class="subject-data">
                {{ this.inventoryData?.before?.user?.name }}
              </p>
            </div>
            <div class="item-row">
              <p class="subject-name">Date and Time</p>
              <p class="subject-data">
                {{
                this.inventoryData?.before
                ? (this.inventoryData?.before?.date | date: "yyyy-MM-dd")
                : "-"
                }}
              </p>
            </div>
            <div class="item-row">
              <p class="subject-name">Fuel Level</p>
              <p class="subject-data">
                {{
                this.inventoryData?.before?.inspectionDetails?.fuelLevel + "%"
                }}
              </p>
            </div>
            <div class="item-row">
              <p class="subject-name">Odometer</p>
              <p class="subject-data">
                {{
                this.inventoryData?.before?.inspectionDetails?.Odometer + "KM"
                }}
              </p>
            </div>
          </div>

          <div *ngIf="inventoryType === 'After'" class="sub-section" style="height: 100%">
            <p class="font-semibold mb-2">After</p>
            <div class="item-row">
              <p class="subject-name">Done By</p>
              <p class="subject-data">
                {{
                this.inventoryData?.after?.user?.name
                ? this.inventoryData?.after?.user?.name
                : "-"
                }}
              </p>
            </div>
            <div class="item-row">
              <p class="subject-name">Date and Time</p>
              <p class="subject-data">
                {{
                this.inventoryData?.after?.date
                ? (this.inventoryData?.after?.date | date: "yyyy-MM-dd")
                : "-"
                }}
              </p>
            </div>
            <div class="item-row">
              <p class="subject-name">Fuel Level</p>
              <p class="subject-data">
                {{
                this.inventoryData?.after?.inspectionDetails?.fuelLevel
                ? this.inventoryData?.after?.inspectionDetails?.fuelLevel +
                "%"
                : "0"
                }}
              </p>
            </div>
            <div class="item-row">
              <p class="subject-name">Odometer</p>
              <p class="subject-data">
                {{
                this.inventoryData?.after.inspectionDetails?.Odometer
                ? this.inventoryData?.after?.inspectionDetails?.Odometer +
                "KM"
                : "0"
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </nz-card>
  </section>

  <section id="recordInfo" class="mt-6">
    <nz-card>
      <div>
        <h5>Record Information</h5>
        <nz-divider></nz-divider>
        <div>
          <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8">
            <div>
              <div class="flex items-center mb-3">
                <label class="w-3/5"></label>
                <div class="w-1/5">
                  <p class="font-semibold">Before</p>
                </div>
                <div class="w-1/5">
                  <p class="font-semibold" *ngIf="inventoryType === 'After'">
                    After
                  </p>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Dashboard</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.dashboard
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.dashboard
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Left Mirror</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.leftMirror
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.leftMirror
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Right Mirror</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.rightMirror
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.rightMirror
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Lighter</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.lighter
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.lighter
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Reverse Camera</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.reverseCam
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.reverseCam
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Sensors</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.sensors
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.sensors
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Keys</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.keys
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="this.inventoryData?.after.recordInformation.keys"></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Radio</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.radio
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.radio
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Bluetooth</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.bluetooth
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.bluetooth
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">A/C</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true"
                    [ngModel]="this.inventoryData?.before.recordInformation.ac"></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="this.inventoryData?.after.recordInformation.ac"></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">License, Insurance, Eco Test</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation
                        .LicenceInsuranceEco
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation
                        .LicenceInsuranceEco
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Sun Shades</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.sunShades
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.sunShades
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Wiper Blades</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.wiperBlades
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.wiperBlades
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Horn</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.horn
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="this.inventoryData?.after.recordInformation.horn"></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">L-Front Light</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.lFrontLight
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.lFrontLight
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">R-Front Light</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.rFrontLight
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.rFrontLight
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">L-Head Light</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.lHeadLight
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.lHeadLight
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">R-Head Light</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.rHeadLight
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.rHeadLight
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">L-Fog Light</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.lFogLight
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.lFogLight
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">R-Fog Light</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.rFogLight
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.rFogLight
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Other Tool Kit</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.otherToolKit
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.otherToolKit
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">L-Signal Light</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.lSignalLight
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.lSignalLight
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">R-Signal Light</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.rSignalLight
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.rSignalLight
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">L-Winker</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.lWinker
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.lWinker
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">R-Winker</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.rWinker
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.rWinker
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">L-Rear Light</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.lRearLight
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.lRearLight
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">R-Rear Light</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.rRearLight
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.rRearLight
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">L-Break Light</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.lBreakLight
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.lBreakLight
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">R-Break Light</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.rBreakLight
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.rBreakLight
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Rear Roof Light</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.RearRoofLight
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.RearRoofLight
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Original Carpets</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation
                        .originalCarpets
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation
                        .originalCarpets
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">3M Carpets</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.mCarpets
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.mCarpets
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Badges</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.badges
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.badges
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Wheel Caps</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.wheelCaps
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.wheelCaps
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Hub Caps</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.hubCaps
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.hubCaps
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Inner Mud Guard</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.innerMudGaurd
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.innerMudGaurd
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Spare Wheel</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.spareWheel
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.spareWheel
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Jack And Handle</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.jackAndHandle
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.jackAndHandle
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Wheel Brush</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.wheelBrush
                    "></label>
                </div>
                <div class="w-1/5">
                  <label style="margin-left: 6px" nz-checkbox [nzDisabled]="true" *ngIf="inventoryType === 'After'"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.wheelBrush
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Electric Air Pump</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation
                        .electricAirPump
                    "></label>
                </div>
                <div class="w-1/5">
                  <label *ngIf="inventoryType === 'After'" style="margin-left: 6px" nz-checkbox [nzDisabled]="true"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation
                        .electricAirPump
                    "></label>
                </div>
              </div>

              <div class="flex items-center mb-3">
                <label class="w-3/5">Tyre Glue</label>
                <div class="w-1/5">
                  <label nz-checkbox style="margin-left: 6px" [nzDisabled]="true" [ngModel]="
                      this.inventoryData?.before.recordInformation.tyreGlue
                    "></label>
                </div>
                <div class="w-1/5">
                  <label *ngIf="inventoryType === 'After'" style="margin-left: 6px" nz-checkbox [nzDisabled]="true"
                    [ngModel]="
                      this.inventoryData?.after.recordInformation.tyreGlue
                    "></label>
                </div>
              </div>
            </div>

            <div>
              <div class="sub-section" style="height: 100%">
                <div class="bg-[#fff8f0] rounded-md px-4 py-4 border border-solid border-[#ffca9e]">
                  <div class="flex items-center mb-3">
                    <div class="ml-2">
                      <label nz-checkbox [disabled]="true" [ngModel]="true"></label>
                    </div>
                    <label class="ml-8">is Functioning or Available</label>
                  </div>

                  <div class="flex items-center">
                    <div class="ml-2">
                      <label nz-checkbox [disabled]="true" [ngModel]="false"></label>
                    </div>
                    <label class="ml-8">is Malfunctioning or Unavailable</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nz-card>
  </section>

  <section id="damages" class="mt-6">
    <nz-card>
      <div>
        <div class="flex flex-col sm:flex-row justify-between gap-2">
          <h5>Damages</h5>
          <div class="flex gap-5">
            <div class="flex">
              <div class="small-badge mt-2" style="background-color: grey"></div>
              <p style="margin-left: 3px">Before</p>
            </div>

            <div class="flex">
              <div class="small-badge mt-2" style="background-color: red"></div>
              <p style="margin-left: 3px">After</p>
            </div>

            <div class="flex">
              <div class="small-badge mt-2" style="background-color: Green"></div>
              <p style="margin-left: 3px">Fixed</p>
            </div>
          </div>
        </div>
        <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8">
          <div>
            <div class="xl:col-span-2 pb-3">
              <nz-alert nzType="info" style="display: inline-block"
                nzMessage="Select the damaged area on the image below to add a new record"
                class="mb-3 custom-alert w-full" nzShowIcon></nz-alert>
            </div>

            <p class="font-medium text-sm mb-8"></p>
            <div class="image-container">
              <img style="max-width: 100%; height: auto" src="assets/img/car-damage.png" alt="Image" #image />
              <div *ngFor="let marker of this.singleDamages">
                <div *ngIf="marker.status !== false && marker.origin === 'After'" class="marker"
                  [style.left.%]="marker.x" [style.top.%]="marker.y">
                  {{ marker.number }}
                </div>
                <div style="background-color: green" *ngIf="marker.status === false" class="marker"
                  [style.left.%]="marker.x" [style.top.%]="marker.y">
                  {{ marker.number }}
                </div>
                <div style="background-color: grey" *ngIf="marker.status === true && marker.origin === 'Before'"
                  class="marker" [style.left.%]="marker.x" [style.top.%]="marker.y">
                  {{ marker.number }}
                </div>
              </div>
            </div>
          </div>

          <div class="sub-section">
            <nz-collapse>
              <nz-collapse-panel *ngFor="let panel of this.singleDamages; let i = index" [nzHeader]="panelHead"
                style="background-color: white; border: 2px solid #d9d9d9" class="font-medium">
                <div class="damage-card mb-3 my-2 flex flex-col sm:flex-row">
                  <div class="w-full p-5">
                    <div class="pl-0 sm:pl-2">
                      <div class="item-row flex mb-2">
                        <div>
                          <p style="font-weight: 400; color: #6d6d6d">
                            Damage Type:
                          </p>
                          <p class="subject-data">{{ panel.damageType }}</p>
                        </div>
                        <div class="flex-grow"></div>
                        <div class="badge-Id">
                          <span class="badge-number" *ngIf="panel.damageType === 'Scratch'">1</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Dent'">2</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Broken'">3</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Cracked'">4</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Missing'">5</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Stain'">6</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Smashed'">7</span>
                        </div>
                      </div>

                      <div class="mb-2">
                        <p class="subject-name">Description:</p>
                        <p class="subject-data">{{ panel.description }}</p>
                      </div>

                      <div class="mb-2">
                        <p class="subject-name">Attachments:</p>
                        <div class="mt-3 flex" style="flex-wrap: wrap">
                          <img *ngFor="let attachment of panel.files" style="margin-left: 3px; margin-bottom: 3px"
                            [src]="attachment.url" class="min-[400px]:hidden" height="80" width="140" alt="Image" />
                          <img *ngFor="let attachment of panel.files" style="margin-left: 3px; margin-bottom: 3px"
                            [src]="attachment.url" class="hidden min-[400px]:block" height="80" width="160"
                            alt="Image" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="">
                  <nz-divider></nz-divider>
                </div>

                <ng-template #panelHead>
                  <div class="flex" style="margin-right: 20px">
                    <div class="badge" *ngIf="panel.status !== false && panel.origin === 'After'">
                      <span class="badge-number">{{ panel.number }}</span>
                    </div>
                    <div class="badge" style="background-color: green" *ngIf="panel.status === false">
                      <span class="badge-number">{{ panel.number }}</span>
                    </div>
                    <div class="badge" style="background-color: grey"
                      *ngIf="panel.status === true && panel.origin === 'Before'">
                      <span class="badge-number">{{ panel.number }}</span>
                    </div>
                  </div>
                  <p class="font-semibold">{{ panel.damageType }}</p>
                  <!-- This div will push the button to the right -->
                </ng-template>
              </nz-collapse-panel>
            </nz-collapse>
          </div>
          <div class="">
            <nz-divider></nz-divider>
          </div>
        </div>
      </div>
    </nz-card>
  </section>

  <section id="damages-table" class="mt-6">
    <nz-card>
      <div class="mb-3">
        <h5>Damages</h5>
      </div>
      <nz-table #basicTable [nzData]="this.singleDamages" [nzShowPagination]="false" [nzScroll]="{ x: 'auto' }"
        nzTableLayout="fixed" nzOuterBordered class="mb-8 table-wSpace-nowrap">
        <thead>
          <tr>
            <th style="background-color: white">
              Damage ID
            </th>
            <th style="background-color: white">
              Damage Type
            </th>
            <th style=" background-color: white">
              Date and Time
            </th>
            <th style=" background-color: white">
              Description
            </th>
            <th style=" background-color: white">
              Attachments
            </th>
            <th style=" background-color: white">Status</th>
            <th style=" background-color: white">
              Comments
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of basicTable.data; let i = index" class="align-baseline">
            <td class="nonWrap">
              <span class="badge-number" *ngIf="data.damageType === 'Scratch'">1</span>
              <span class="badge-number" *ngIf="data.damageType === 'Dent'">2</span>
              <span class="badge-number" *ngIf="data.damageType === 'Broken'">3</span>
              <span class="badge-number" *ngIf="data.damageType === 'Cracked'">4</span>
              <span class="badge-number" *ngIf="data.damageType === 'Missing'">5</span>
              <span class="badge-number" *ngIf="data.damageType === 'Stain'">6</span>
              <span class="badge-number" *ngIf="data.damageType === 'Smashed'">7</span>
            </td>
            <td class="nonWrap">{{ data.damageType }}</td>
            <td class="nonWrap">
              {{
              data.timestamp
              ? (data.timestamp | date: "yyyy-MM-dd | h:mm a")
              : "-"
              }}
            </td>
            <td class="">{{ data.description }}</td>
            <td class="nonWrap">
              <div class="flex" *ngFor="let file of data.files">
                <a [href]="file.url" target="_blank">
                  <span nz-icon nzType="file" nzTheme="outline" class="text-primary text-xs"></span>
                  <span class="text-black text-xs"> - {{ file.name }}</span>
                </a>
              </div>
            </td>
            <td>
              <nz-tag *ngIf="data.status === false" [nzColor]="'#3ab200'" class="rounded-full">Fixed
              </nz-tag>
              <nz-tag *ngIf="data.status !== false" [nzColor]="'#F3454C'" class="rounded-full">Not Fixed
              </nz-tag>
            </td>
            <td>{{ data.comment }}</td>
          </tr>
        </tbody>
      </nz-table>
    </nz-card>
  </section>

  <section id="remarks" class="mt-6">
    <nz-card>
      <div class="mb-3">
        <h5>Remarks</h5>
      </div>
      <div class="sub-section mb-10">
        <p class="font-medium text-justify mb-2">
          <span class="font-bold">Before: </span>
          {{

          (this.inventoryData?.before.remarks.remark
          ? this.inventoryData?.before.remarks.remark
          : "-")
          }}
        </p>
        <p class="font-medium" *ngIf="inventoryType === 'After'">
          <span class="font-bold">After: </span>
          {{

          (this.inventoryData?.after.remarks.remark
          ? this.inventoryData?.after.remarks.remark
          : "-")
          }}
        </p>
      </div>
    </nz-card>
  </section>

</div>

<nz-modal [(nzVisible)]="isShowReport" [nzTitle]="modalTitle12" [nzContent]="modalContent12" [nzFooter]="modalFooter12"
  (nzOnCancel)="handleCancel()" nzClosable="false">
  <ng-template #modalTitle12>
    <div class="flex justify-between items-center my-4">
      <h4>Initial Inventory Report</h4>
      <button *appHasAnyPrivilege="''" nz-button nzType="primary" [disabled]="!this.pdfLoader" (click)="viewPdf()">
        Preview
      </button>
    </div>
  </ng-template>

  <ng-template #modalContent12>
    <div class="my-4">
      <p style="font-weight: normal; color:#F06A21" *ngIf="!this.pdfLoader">
        Report Generating ....
      </p>
      <p style="font-weight: normal" *ngIf="this.pdfLoader">
        Report Generated Successfully!
      </p>
    </div>
  </ng-template>

  <ng-template #modalFooter12>
    <div class="flex justify-between items-center my-4">
      <button nz-button nzType="default" style="color: white; background: #9a9a9a" (click)="handleCancel()">
        Cancel
      </button>
      <div class="flex gap-2">
        <button *appHasAnyPrivilege="''" nz-button nzType="default" [disabled]="!this.pdfLoader" class="outline-button"
          (click)="downloadPdf()">
          Download
        </button>
        <button nz-button nzType="default" [disabled]="!this.pdfLoader" class="outline-button" (click)="emailPdf()">
          Send
        </button>
        <button nz-button nzType="default" [disabled]="!this.pdfLoader" class="outline-button" (click)="printReport()">
          Print
        </button>
      </div>
    </div>
  </ng-template>
</nz-modal>


<div [ngClass]="loading ? 'block' : 'hidden'">
  <app-single-view-skeleton-template [typeName]="'single-view'"></app-single-view-skeleton-template>
</div>

<app-generate-inventory-report-popup *ngIf="isVisibleGenerateInventoryReport"
  (handleGenerateInventoryReportOnChange)="onGetGenerateInventoryReportChange($event)"
  [isVisibleGenerateInventoryReport]="isVisibleGenerateInventoryReport" [inventoryId]="inventoryId"
  [bookingData]="bookingData"></app-generate-inventory-report-popup>